import { IconDefinition } from "./types";

const user: IconDefinition = {
  iconName: "user",
  width: 448,
  height: 512,
  svgPathData:
    "M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM50.2 512l49.2-160 249.1 0 49.2 160 50.2 0-64-208-320 0-64 208 50.2 0zM224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256z",
  iconType: "fill",
  fontAwesomeName: "user",
  unicode: 0xf007,
};

export { user };
